import React from 'react';
import styled, { StylesProps } from '../../../lib/styles';
import { compose } from 'recompose';

import videoStyles, { videoFrameStyles } from './Video_styles';

export interface VideoProps {
  visibleOnLoad?: boolean;
  bg_url?: string;
  video_id?: string;
  caption: string;
}

export interface VideoFrameProps {
  video_id: string;
  onPlay?: (playing: boolean) => any;
}

const VideoFrame = styled(videoFrameStyles)(
  ({
    video_id,
    styles,
  }: VideoFrameProps & StylesProps<typeof videoFrameStyles>) => (
    <div className={styles.container}>
      <iframe
        src={`https://www.youtube.com/embed/${video_id}`}
        width={'100%'}
        height={'100%'}
      />
    </div>
  )
);

const Video = ({
  bg_url,
  video_id,
  caption,
  styles,
}: VideoProps & StylesProps<typeof videoStyles>) => (
  <div>
    <div className={styles.container}>
      {bg_url && <div className={styles.bg} />}
      {video_id && <VideoFrame video_id={video_id} />}
    </div>
    {caption && <div className={styles.caption}>{caption}</div>}
  </div>
);

export default compose(styled(videoStyles))(Video);
